import ApiResourceManager from '../ApiResourceManager';

/**
 * A partner's one non-billable test restaurant (Asana 1219224914680039).
 *
 * Every call takes an optional partner id. Without it, the partner's own
 * routes are used — partner admins are pinned to their provider by the
 * backend. With it, the super-admin routes are used on behalf of that
 * partner, the same split the paywall's entitlements use.
 */
export default class TestRestaurantsManager extends ApiResourceManager {
  #route = (serviceProviderId, path) =>
    serviceProviderId
      ? {
          url: `/provider-licenses${path}`,
          headers: { 'x-on-behalf-of-service-provider': serviceProviderId },
        }
      : { url: `/partner-licenses${path}` };

  /** `{ current, restaurants }`: the slot is taken exactly when `current` is set. */
  state = (serviceProviderId = undefined) =>
    this.request({ method: 'GET', ...this.#route(serviceProviderId, '/test-restaurant') });

  designate = (companyId, serviceProviderId = undefined) =>
    this.request({
      method: 'PUT',
      ...this.#route(serviceProviderId, `/companies/${companyId}/test-designation`),
    });

  /** Removing it from a live restaurant takes that restaurant offline. */
  remove = (companyId, serviceProviderId = undefined) =>
    this.request({
      method: 'DELETE',
      ...this.#route(serviceProviderId, `/companies/${companyId}/test-designation`),
    });

  /** Super admins only: every partner's test restaurant with its GMV this month. */
  list = (params = {}) =>
    this.request({
      method: 'GET',
      url: '/provider-licenses/test-restaurants',
      params,
    });
}
